var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 32 32",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m22.985 6.904.025 3.314h1.578c1.155 0 2.079.943 2.079 2.091v12.279a2.085 2.085 0 0 1-2.079 2.09H7.412a2.085 2.085 0 0 1-2.079-2.09V12.309c0-1.175.977-1.997 1.996-2.375C11.73 8.297 16.257 6.888 20.713 5.4c.991-.256 2.197.416 2.272 1.504m2.04 13.276v-3.464c-.001-.055-.032-.072-.06-.072h-3.991c-.937 0-1.738.79-1.738 1.804s.8 1.804 1.738 1.804h3.992c.018 0 .058-.03.06-.072m0-5.177h-4.051c-1.882 0-3.379 1.563-3.379 3.445 0 1.883 1.497 3.446 3.379 3.446h4.052v2.694a.444.444 0 0 1-.438.449H7.412a.443.443 0 0 1-.438-.45V12.31c0-.255.203-.45.438-.45h17.176c.235 0 .438.195.438.45zm-3.656-4.785h-9.83c3.207-1.095 6.42-2.167 9.633-3.24.111-.01.178.079.18.186.02 1.017.016 2.036.017 3.054",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWallet);
export default __webpack_public_path__ + "static/media/IcoWallet.0fb39767f8383fba70b349f0682ac33c.svg";
export { ForwardRef as ReactComponent };